import clsx from 'clsx';
import * as React from 'react';
import { match, P } from 'ts-pattern';
import { User } from '@ovpn-ui/icons';
import { colors } from '@ovpn-ui/styles';
import Text from '../Text';
import Image from './AvatarImage';
import * as Styled from './Avatar.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getBadgeSize = size => match(size).with('sm', () => '10px').with('md', () => '12px').with('lg', () => '15px').exhaustive();
const getTextVariant = size => match(size).with('sm', () => 'textXs').with('md', () => 'textSm').with('lg', () => 'textMd').exhaustive();
const Avatar = /*#__PURE__*/React.forwardRef(function Avatar({
  size = 'md',
  title,
  description,
  onClick,
  src,
  name,
  logo,
  status,
  icon,
  className,
  ...props
}, ref) {
  var _User;
  const [imageError, setImageError] = React.useState(false);
  const shouldShowStatusIndicator = logo === undefined && status !== undefined;
  const badgeSize = React.useMemo(() => getBadgeSize(size), [size]);
  const children = React.useMemo(() => {
    if (src && imageError && name || !src && name) {
      return /*#__PURE__*/_jsx(Text, {
        variant: getTextVariant(size),
        weight: "medium",
        children: name
      });
    }
    return icon ? /*#__PURE__*/React.cloneElement(icon, {
      size
    }) : _User || (_User = /*#__PURE__*/_jsx(User, {
      size: size
    }));
  }, [src, imageError, name, size, icon]);
  return /*#__PURE__*/_jsxs(Styled.Root, {
    ref: ref,
    className: clsx('ovpn-avatar', className),
    ...props,
    children: [/*#__PURE__*/_jsxs(Styled.Avatar, {
      size: size,
      onClick: onClick,
      className: "ovpn-avatar-figure",
      tabIndex: onClick ? 0 : undefined,
      role: onClick ? 'button' : undefined,
      children: [/*#__PURE__*/_jsx(Styled.Main, {
        children: src && !imageError ? /*#__PURE__*/_jsx(Image, {
          src: src,
          alt: name,
          className: "ovpn-avatar-img",
          handleImageError: () => setImageError(true)
        }) : children
      }), shouldShowStatusIndicator && /*#__PURE__*/_jsx(Styled.Status, {
        className: "ovpn-avatar-status",
        "data-testid": "ovpn-avatar-status-indicator",
        size: badgeSize,
        isOnline: status
      }), logo && /*#__PURE__*/_jsx(Styled.Logo, {
        className: "ovpn-avatar-logo",
        size: badgeSize,
        children: logo
      })]
    }), /*#__PURE__*/_jsxs(Styled.Label, {
      className: "ovpn-avatar-label",
      size: size,
      children: [match(title).with(P.string, content => /*#__PURE__*/_jsx(Text, {
        variant: "textSm",
        weight: "medium",
        className: "ovpn-avatar-title",
        children: content
      })).with(P.nullish, () => null).otherwise(reactElement => reactElement), match(description).with(P.string, content => /*#__PURE__*/_jsx(Text, {
        color: colors.neutralTextSubtitle,
        className: "ovpn-avatar-description",
        variant: size === 'sm' ? 'textXs' : 'textSm',
        children: content
      })).with(P.nullish, () => null).otherwise(reactElement => reactElement)]
    })]
  });
});
export default Avatar;